module.exports = __webpack_public_path__ + "img/blank.ec0d2796.png";